import React, { useState } from "react";
import {
  CModal,
  CModalHeader,
  CModalTitle,
  CModalBody,
  CButton,
} from "@coreui/react-pro";
import CIcon from "@coreui/icons-react";
import { cilBook, cilChevronRight, cilDescription } from "@coreui/icons";

const AppHeaderManualBook = () => {
  const [selectedModul, setSelectedModul] = useState(null);
  const [formVisible, setFormVisible] = useState(false);
  const [modalVisible, setModalVisible] = useState(false);
  const [pdfUrl, setPdfUrl] = useState("");

  const modulOptions = [
    {
      value: "1.%20Master.pdf",
      label: "Modul Master",
      desc: "Panduan lengkap penggunaan fitur master data",
    },
    {
      value: "2.Pengaturan.pdf",
      label: "Modul Pengaturan",
      desc: "Panduan untuk konfigurasi dan pengaturan sistem",
    },
    {
      value: "produksi.pdf",
      label: "Modul Produksi",
      desc: "Panduan lengkap alur kerja dan operasional produksi",
    },
    {
      value: "tagihan.pdf",
      label: "Modul Tagihan",
      desc: "Panduan lengkap pencatatan dan pengelolaan tagihan",
    },
    {
      value: "MANUAL%20BOOK%20PERMINTAAN%20-%20PENERIMAAN%20CABANG.pdf",
      label: "Permintaan - Penerimaan Cabang",
      desc: "Panduan alur permintaan dan penerimaan barang cabang",
    },
    {
      value: "Master%20Shift%20&%20Shift%20Karyawan.pdf",
      label: "Master Shift - Shift Karyawan",
      desc: "Panduan master shift dan shift karyawan",
    },
    {
      value: "Tutorial%20Masuk%20ke%20Notif%20Telegram.pdf",
      label: "Tutorial Notif Telegram",
      desc: "Panduan untuk masuk ke notifikasi Telegram",
    },
    {
      value:
        "Tutorial%20Mengatur%20Akses%20Kamera%20pada%20URL%20Local%20Kalasan%20Ismud.pdf",
      label: "Tutorial Akses Kamera",
      desc: "Panduan mengatur akses kamera pada URL local",
    },
    {
      value: "ABSENSI%20PERSONALIA.pdf",
      label: "Tutorial Absensi Personalia",
      desc: "Panduan absensi menggunakan face recognition",
    },
    {
      value: "PANDUAN%20MODUL%20PENGUMUMAN.pdf",
      label: "Modul Pengumuman",
      desc: "Panduan lengkap penggunaan modul pengumuman",
    },
    {
      value: "Manual%20Book%20Permintaan%20Sayur%20Karyawan.pdf",
      label: "Tutorial Permintaan Sayur Karyawan",
      desc: "Panduan melakukan permintaan sayur karyawan",
    },
    {
      value: "PANDUAN%20SURAT%20PERINGATAN.pdf",
      label: "Modul Surat Peringatan",
      desc: "Panduan lengkap penggunaan modul surat peringatan",
    },
    {
      value: "panduan%20aset%20dan%20inventaris.pdf",
      label: "Panduan Aset dan Inventaris",
      desc: "Panduan lengkap pengelolaan aset dan inventaris",
    },
    {
      value: "PANDUAN%20PENGAJUAN%20CUTI.pdf",
      label: "Panduan Pengajuan Cuti",
      desc: "Panduan pengajuan cuti",
    },
    {
      value: "Panduan%20Pengajuan%20Izin.pdf",
      label: "Panduan Pengajuan Izin",
      desc: "Panduan pengajuan izin",
    },
    {
      value: "Panduan%20Pengajuan%20Lembur.pdf",
      label: "Panduan Pengajuan Lembur",
      desc: "Panduan pengajuan lembur",
    },
    {
      value: "PANDUAN%20PINJAMAN%20KARYAWAN.pdf",
      label: "Panduan Pinjaman Karyawan",
      desc: "Panduan lengkap penggunaan fitur pinjaman karyawan",
    },
    {
      value: "PANDUAN%20PAYROLL%20KARYAWAN.pdf",
      label: "Panduan Payroll Karyawan",
      desc: "Panduan lengkap penggunaan fitur payroll karyawan",
    },
    {
      value: "PANDUAN%20PINJAM%20BARANG.pdf",
      label: "Panduan Pinjam Barang",
      desc: "Panduan lengkap penggunaan fitur pinjam barang",
    },
    {
      value: "PANDUAN%20TEKNISI.pdf",
      label: "Panduan Teknisi",
      desc: "Panduan lengkap penggunaan fitur teknisi",
    },
  ];

  const handleChangeModul = (data) => {
    setSelectedModul(data);
    if (data && data.value) {
      let baseUrl =
        process.env.REACT_APP_BASE_URL || "http://localhost:8000/api";
      if (baseUrl && baseUrl.endsWith("/api")) {
        baseUrl = baseUrl.substring(0, baseUrl.length - 4);
      }
      const url = `${baseUrl}/files/manual-book/${data.value}`;

      setPdfUrl(url);
      setFormVisible(false);
      setModalVisible(true);
    }
  };

  const handleCloseModal = () => {
    setModalVisible(false);
    setSelectedModul(null);
    setPdfUrl("");
    setFormVisible(true);
  };

  return (
    <>
      <div
        className="me-md-3 d-flex align-items-center"
        style={{ height: "38px" }}
      >
        <CButton
          color="light"
          className="d-flex align-items-center border shadow-sm h-100"
          style={{
            borderRadius: "4px",
            padding: "0 12px",
            fontWeight: "500",
            transition: "all 0.3s",
          }}
          onClick={() => setFormVisible(true)}
          onMouseEnter={(e) =>
            (e.currentTarget.style.backgroundColor = "#e2e8f0")
          }
          onMouseLeave={(e) =>
            (e.currentTarget.style.backgroundColor = "#f8f9fa")
          }
        >
          <div
            className="bg-primary bg-opacity-10 text-primary rounded d-flex align-items-center justify-content-center me-2"
            style={{ width: "24px", height: "24px" }}
          >
            <CIcon icon={cilBook} size="sm" />
          </div>
          Manual Book
        </CButton>
      </div>

      <CModal
        alignment="center"
        visible={formVisible}
        onClose={() => setFormVisible(false)}
      >
        <CModalHeader
          onClose={() => setFormVisible(false)}
          className="border-0 pb-0"
        >
          <CModalTitle className="fs-4 fw-bold">Pilih Modul</CModalTitle>
        </CModalHeader>
        <CModalBody
          className="pt-2 pb-4"
          style={{ maxHeight: "60vh", overflowY: "auto" }}
        >
          <div className="d-flex flex-column gap-3">
            {modulOptions.map((modul, idx) => (
              <div
                key={idx}
                onClick={() => handleChangeModul(modul)}
                className="d-flex align-items-center justify-content-between p-3 border rounded shadow-sm"
                style={{
                  cursor: "pointer",
                  transition: "all 0.2s ease",
                  backgroundColor: "#fff",
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = "translateY(-2px)";
                  e.currentTarget.style.borderColor = "#321fdb";
                  e.currentTarget.style.boxShadow = "0 4px 8px rgba(0,0,0,0.1)";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = "translateY(0)";
                  e.currentTarget.style.borderColor = "#dee2e6";
                  e.currentTarget.style.boxShadow =
                    "0 2px 4px rgba(0,0,0,0.05)";
                }}
              >
                <div className="d-flex align-items-center">
                  <div
                    className="bg-primary bg-opacity-10 text-primary p-2 rounded-circle me-3 d-flex align-items-center justify-content-center"
                    style={{ width: "45px", height: "45px" }}
                  >
                    <CIcon icon={cilDescription} size="lg" />
                  </div>
                  <div>
                    <div
                      className="fw-semibold text-dark"
                      style={{ fontSize: "1.05rem" }}
                    >
                      {modul.label}
                    </div>
                    <div className="text-medium-emphasis small">
                      {modul.desc}
                    </div>
                  </div>
                </div>
                <div className="bg-light rounded-circle p-2 d-flex align-items-center justify-content-center">
                  <CIcon icon={cilChevronRight} className="text-secondary" />
                </div>
              </div>
            ))}
          </div>
        </CModalBody>
      </CModal>

      <CModal size="xl" visible={modalVisible} onClose={handleCloseModal}>
        <CModalHeader onClose={handleCloseModal}>
          <CModalTitle>{selectedModul?.label}</CModalTitle>
        </CModalHeader>
        <CModalBody style={{ height: "80vh", padding: 0 }}>
          {pdfUrl && (
            <iframe
              src={pdfUrl}
              title="PDF Preview"
              width="100%"
              height="100%"
              style={{ border: "none" }}
            />
          )}
        </CModalBody>
      </CModal>
    </>
  );
};

export default AppHeaderManualBook;
